import React, { useState, useEffect } from 'react';
import { Button, Modal as ModalAntd, Space, Table, Tooltip, Tag } from 'antd';
import {
  ReloadOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
} from '@ant-design/icons';
import AddSupplierContact from '../SupplierContacts/AddSupplierContact';
import Modal from '../../../General/Modal';
import { fetchApi } from '../../../../helpers/fetch';
import { getAccessTokenApi } from '../../../../api/auth';
import {
  METHOD_DELETE,
  METHOD_GET,
  ROL_ADMIN,
  ROL_LAYOUT,
  ROL_MANAGER,
  ROL_PRICING,
} from '../../../../utils/constants';
import { API_URL_SUPPLIER_CONTACTS } from '../../../../helpers/urls';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import EditSupplierContact from '../SupplierContacts/EditSupplierContact';
import { formatPhoneNumber } from '../../../../utils/general';
import useUser from '../../../../hooks/useUser';

const SupplierContacts = ({ supplier }) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [reloadContacts, setReloadContacts] = useState(true);
  const [titleModal, setTitleModal] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;
  const { confirm } = ModalAntd;
  const token = getAccessTokenApi();
  let { supplierId } = useParams();
  const [SupplierContacts, setSupplierContacts] = useState([]);
  const { person } = useUser();

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    const config = {
      method: METHOD_GET,
      url: `Supplier/${supplierId}/Contacts`,
      data: null,
      token,
    };
    fetchApi(config)
      .then((response) => {
        if (response) {
          let supContacts = response.result;

          if (supContacts) {
            supContacts.map((cat, index) => {
              cat['key'] = index;
            });
          }
          setSupplierContacts(supContacts);
        }
        setReloadContacts(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reloadContacts, supplierId, token]);

  const showModal = (type, contactId) => {
    if (type === 'Add') {
      setModalIsVisible(true);
      setTitleModal(`Agregar contacto proveedor ${supplier.name}`);
      setContextModal(
        <AddSupplierContact
          setModalIsVisible={setModalIsVisible}
          setReloadContacts={setReloadContacts}
          supplierId={supplierId}
        ></AddSupplierContact>
      );
    } else if (type === 'Edit') {
      setModalIsVisible(true);
      setTitleModal(`Editar contacto proveedor ${supplier.name}`);
      setContextModal(
        <EditSupplierContact
          setModalIsVisible={setModalIsVisible}
          setReloadContacts={setReloadContacts}
          contactId={contactId}
        ></EditSupplierContact>
      );
    } else if (type === 'Watch') {
      setModalIsVisible(true);
      setTitleModal('Contacto #123');
      setContextModal(
        <AddSupplierContact
          setModalIsVisible={setModalIsVisible}
          setReloadContacts={setReloadContacts}
          supplierId={supplierId}
          type="watch"
        ></AddSupplierContact>
      );
    }
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      align: 'center',
      fixed: 'left',
    },
    {
      title: 'Apellido paterno',
      dataIndex: 'lastName',
      key: 'lastName',
      width: 150,
      align: 'center',
    },
    {
      title: 'Apellido materno',
      dataIndex: 'mothersLastName',
      key: 'mothersLastName',
      width: 150,
      align: 'center',
    },
    {
      title: 'Rol',
      dataIndex: 'rolesDescription',
      key: 'rolesDescription',
      width: 160,
      align: 'center',
      render: (rolesDescription, contact) => (
        <>
          {rolesDescription && (
            <Tag
              color={
                contact.roles === '152'
                  ? 'blue'
                  : contact.roles === '153'
                  ? 'orange'
                  : 'green'
              }
            >
              {rolesDescription}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: 'Teléfono casa/oficina',
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
      align: 'center',
      render: (phone) => <span>{formatPhoneNumber(phone)}</span>,
    },
    {
      title: 'Celular 1',
      dataIndex: 'cellPhone1',
      key: 'cellPhone1',
      width: 150,
      align: 'center',
      render: (cellPhone1) => <span>{formatPhoneNumber(cellPhone1)}</span>,
    },
    {
      title: 'Celular 2',
      dataIndex: 'cellPhone2',
      key: 'cellPhone2',
      width: 100,
      align: 'center',
      render: (cellPhone2) => <span>{formatPhoneNumber(cellPhone2)}</span>,
    },
    {
      title: 'Correo electrónico',
      dataIndex: 'email',
      key: 'email',
      width: 200,
      align: 'center',
    },

    {
      title: 'Acción',
      key: 'action',
      width: 120,
      render: (text, record) => (
        <>
          {[ROL_PRICING, ROL_ADMIN, ROL_LAYOUT].some((r) =>
            person.roles.includes(r)
          ) && (
            <>
              <Space size="middle">
                <Tooltip title="Editar">
                  <Button
                    onClick={() => showModal('Edit', record.id)}
                    type="primary"
                  >
                    <EditOutlined />
                  </Button>
                </Tooltip>

                <Tooltip title="Eliminar">
                  <Button
                    danger
                    type="primary"
                    onClick={() => handleDeleteContact(record.id)}
                  >
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Space>
            </>
          )}
        </>
      ),
      align: 'center',
    },
  ];

  const handleDeleteContact = (id) => {
    confirm({
      title: 'Eliminar contacto',
      icon: <ExclamationCircleOutlined />,
      content: '¿Estás seguro que deseas eliminar el contacto seleccionado?',
      okText: 'Si',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteContact(id);
      },
      onCancel() {},
    });
  };

  const deleteContact = async (id) => {
    let values = {};
    values['supplierId'] = supplierId;
    values['id'] = id;
    const config = {
      method: METHOD_DELETE,
      url: `${API_URL_SUPPLIER_CONTACTS}`,
      data: values,
      token,
      showNotification: true,
    };
    const result = await fetchApi(config);

    if (result) {
      if (result.statusCode === 200) {
        setReloadContacts(true);
      }
    }
  };

  return (
    <div>
      {[ROL_PRICING, ROL_ADMIN, ROL_LAYOUT].some((r) =>
        person.roles.includes(r)
      ) && (
        <Button
          className="btn-download"
          onClick={() => showModal('Add')}
          icon={<PlusCircleOutlined />}
        >
          Agregar
        </Button>
      )}
      {/* <Button
                disabled={!hasSelected}
                className="btn-delete"
                onClick={(e) => handleDeleteContact(rowSelection)}
                icon={<DeleteOutlined />}
            >
                Eliminar
            </Button> */}
      <Button
        className="btn-download"
        icon={<ReloadOutlined />}
        onClick={(e) => setReloadContacts(true)}
      >
        Refrescar
      </Button>
      {selectedRowKeys.length > 0 && (
        <p>Seleccionados: {selectedRowKeys.length} elementos</p>
      )}
      {/* <Button className="btn-download" onClick={() => showModal('Edit')}>
                Clientes
            </Button> */}
      <Table
        // rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        dataSource={SupplierContacts}
        columns={columns}
        bordered
        size="middle"
        scroll={{ x: 1500 }}
        // setSelectedRowKeys
        className="table-striped-rows"
        // rowSelection={rowSelection}
        loading={reloadContacts}
      />

      <Modal
        title={titleModal}
        visible={modalIsVisible}
        setIsVisible={setModalIsVisible}
        width={1000}
      >
        {contextModal}
      </Modal>
    </div>
  );
};

export default SupplierContacts;
